<template>
    <section>
        <div class="category-filter rl-row-1440">
            <!-- <div
                class="header"
                @click="collapseFilter()">
                <div class="current-category">ALL</div>
                <div
                    class="filter-btn">Filter Category
                    <i
                        :class="{'rotate':isCollapseFilter}"
                        class="el-icon-arrow-up"/>
                </div>
            </div> -->
            <el-collapse-transition>
                <div
                    v-show="isCollapseFilter"
                    class="content">
                    <div
                        v-for="(item, index) in categories"
                        :key="index"
                        class="category-item">
                        <div class="title">{{ item.title }}</div>
                        <div
                            v-for="(subItem, index) in item.items"
                            :key="index"
                            class="sub-category">
                            <router-link :to="{path:item.link+'/'+subItem.type}">
                                {{ subItem.text }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </el-collapse-transition>
        </div>
        <div class="index-tab">
            <div
                v-for="(item, index) in pageData"
                :key="index"
                :class="{bggray:((index + 1) / 2)===1}">
                <div class="rl-container rl-row-1440">
                    <div class="content rl-row-90">
                        <div
                            v-if="item.ProductType=='ic'"
                            class="title rl-row-bottom-60">The Latest iClone Video</div>
                        <div
                            v-else-if="item.ProductType=='cc'"
                            class="title rl-row-bottom-60">The Latest Character Creator Video</div>
                        <div
                            v-else-if="item.ProductType=='cta'"
                            class="title rl-row-bottom-60">The Latest Cartoon Animator Video</div>
                        <!-- <div
                    v-else-if="item.ProductType=='crtl'"
                    class="title">The Latest CrazyTalk Video</div> -->
                        <el-tabs
                            :stretch="true"
                            v-model="activeName[item.ProductType]"
                            @tab-click="handleClick">
                            <template
                                v-for="(subItem, index) in item.Info"
                                id="test">
                                <el-tab-pane
                                    v-if="subItem.VideoType==3"
                                    :name="subItem.VideoType.toString()"
                                    :key="index"
                                    label="FEATURED SHOWCASE">
                                    <div class="video-tab">
                                        <videoTab
                                            v-for="(video, index) in subItem.Data"
                                            :key="index"
                                            :video="video"
                                            :imgdomain="imgdomain"
                                            :current-tab="currentTab"
                                            :current-type="$route.params.type"/>
                                        <router-link
                                            :to="{path:'/' + productName[item.ProductType] + '/' + productTab[subItem.VideoType]}"
                                            class="page-link">
                                            Watch More >
                                        </router-link>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane
                                    v-else-if="subItem.VideoType==0"
                                    :name="subItem.VideoType.toString()"
                                    :key="index"
                                    label="PRODUCT DEMO">
                                    <div class="video-tab">
                                        <videoTab
                                            v-for="(video, index) in subItem.Data"
                                            :key="index"
                                            :video="video"
                                            :imgdomain="imgdomain"
                                            :current-tab="currentTab"
                                            :current-type="$route.params.type"/>
                                        <router-link
                                            :to="{path:'/' + productName[item.ProductType] + '/' + productTab[subItem.VideoType]}"
                                            class="page-link">
                                            Watch More >
                                        </router-link>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane
                                    v-else-if="subItem.VideoType==4"
                                    :name="subItem.VideoType.toString()"
                                    :key="index"
                                    label="TUTORIALS">
                                    <div class="video-tab">
                                        <videoTab
                                            v-for="(video, index) in subItem.Data"
                                            :key="index"
                                            :video="video"
                                            :imgdomain="imgdomain"
                                            :current-tab="currentTab"
                                            :current-type="$route.params.type"/>
                                        <router-link
                                            :to="{path:'/' + productName[item.ProductType] + '/' + productTab[subItem.VideoType]}"
                                            class="page-link">
                                            Watch More >
                                        </router-link>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane
                                    v-else-if="subItem.VideoType==5"
                                    :name="subItem.VideoType.toString()"
                                    :key="index"
                                    label="CONTENT TRAILERS">
                                    <div class="video-tab">
                                        <videoTab
                                            v-for="(video, index) in subItem.Data"
                                            :key="index"
                                            :video="video"
                                            :imgdomain="imgdomain"
                                            :current-tab="currentTab"
                                            :current-type="$route.params.type"/>
                                        <router-link
                                            :to="{path:'/' + productName[item.ProductType] + '/' + productTab[subItem.VideoType]}"
                                            class="page-link">
                                            Watch More >
                                        </router-link>
                                    </div>
                                </el-tab-pane>
                            </template>
                        </el-tabs>
                </div></div>
            </div>
        </div>
    </section>
</template>
<script>
    import { mapGetters } from "vuex";
    import videoTab from "./video-tab";
    import store from "@/store";
    export default {
        components: {
            videoTab: videoTab
        },
        metaInfo: {
            title: "Reallusion TV", // set a title
            meta: [
                {
                    // set link
                    property: "og:title",
                    content: "Reallusion TV"
                },
                {
                    // set link
                    property: "og:type",
                    content: "website"
                },
                {
                    // set link
                    property: "og:url",
                    content: "https://www.reallusion.com/reallusiontv/"
                },
                {
                    // set link
                    property: "og:site_name",
                    content: "Reallusion TV"
                }
            ]
        },
        data () {
            return {
                serverConfig: window.rlServerURL,
                imgdomain: "https://www.reallusion.com",
                isCollapseFilter: false,
                activeName: {
                    ic: "0",
                    cc: "0",
                    cta: "0",
                    crtl: "0"
                },
                productName: {
                    ic: "iclone",
                    cc: "character-creator",
                    cta: "cartoon-animator",
                    crtl: "crazytalk"
                },
                productTab: {
                    "0": "product-demo",
                    "3": "feature-showcase",
                    "4": "tutorials",
                    "5": "content-trailers"
                },
                currentTab: 0
            };
        },
        computed: {
            ...mapGetters({ pageData: "videoData" }),
            ...mapGetters({ categories: "categories" })
        },
        created: function () {
            this.getData();
        },
        methods: {
            collapseFilter: function () {
                this.isCollapseFilter = !this.isCollapseFilter;
            },
            getData: function () {
                var data = {
                    SearchConditions: [
                        {
                            ProductType: "ic",
                            VideoType: [0, 3, 4, 5],
                            MaxResults: 3
                        },
                        {
                            ProductType: "cta",
                            VideoType: [0, 3, 4, 5],
                            MaxResults: 3
                        },
                        {
                            ProductType: "cc",
                            VideoType: [0, 3, 4, 5],
                            MaxResults: 3
                        }
                    ]
                };
                store.dispatch("getVideoData", data).then(() => {});
            },
            handleClick: function (tab, event) {
                this.currentTab = parseInt(tab._uid + tab.index);
            },
            labelName: function (type) {
                let text;
                switch (type) {
                    case 0:
                        text = "ProductDemo";
                        break;
                    case 1:
                        text = "MediaBuzz";
                        break;
                    case 2:
                        text = "CaseStudy";
                        break;
                    case 3:
                        text = "FeaturedMovie";
                        break;
                    case 4:
                        text = "Tutorial";
                        break;
                    case 5:
                        text = "ContentTrailer";
                        break;
                    case 6:
                        text = "LiveShowFor2D";
                        break;
                    case 7:
                        text = "LiveShowFor3D";
                        break;
                }
                return text;
            }
        }
    };
</script>
<style lang="scss">
    .index-tab .bggray{
        background-color: #f0f0f0;
    }
    @media (max-width: 1180px) {
        .index-tab{
            .el-tabs__nav{
                flex-wrap: wrap;
            }
            .el-tabs__nav.is-stretch>*{
                flex: calc((100% - 15px) / 2);
            }
            .el-tabs__item + .el-tabs__item{
                margin-left: 0;
            }
            .el-tabs__nav .el-tabs__item:nth-of-type(odd){
                margin-left: 15px;
            }
            .el-tabs__nav .el-tabs__item:nth-of-type(2),
            .el-tabs__nav .el-tabs__item:nth-of-type(3){
                margin-bottom: 15px;
            }
        }
    }
    @media (max-width: 561px) {
         .index-tab{
            .el-tabs__nav .el-tabs__item:nth-of-type(odd){
                    margin-left: 0;
                }
            .el-tabs__nav .el-tabs__item:nth-of-type(4){
                margin-bottom: 15px;
            }
         }
    }
</style>



// WEBPACK FOOTER //
// src/components/index.vue